import React, { Component } from "react";
import "./drop-down.css";

class DropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: this.props.isOneDivv || false,
    };
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  setOpen = (isOpen) => {
    this.setState({ isOpen });
  };

  render() {
    const { title, options, id } = this.props;
    const { isOpen } = this.state;

    return (
      <div className={`dropdown-menu ${isOpen ? "open" : ""}`} id={id}>
        {!this.props.isOneDivv && (
          <div className="dropdown-header" onClick={this.toggleDropdown}>
            {isOpen ? (
              <span className="arrow-up">&#9650;</span>
            ) : (
              <span className="arrow-down">&#9660;</span>
            )}
            <div className="Title">{title}</div>
          </div>
        )}

        <div className="dropdown-options">
          {options.map((option, index) => {
            if (this.props.DivisionID === option.DevisionID) {
              return (
                <li
                  className="li"
                  key={index}
                  onClick={() => this.props.SelectZone(option)}
                >
                  {option.Description}
                  <hr />
                </li>
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  }
}

export default DropDown;
